import React from 'react'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { Controller } from 'react-hook-form'
import { frFR } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import 'dayjs/locale/fr'
import PatientFormField from '../PatientFormField'
import { usePatientFormContext } from '../../context/PatientFormContext'
import { patientFormErrors } from '../../_errors'
import { useFormContextPatient } from '../_utils'

dayjs.extend(utc)
dayjs.locale('fr')

const BirthDate = () => {
    const { control } = useFormContextPatient()

    const {
        state: { isDisabled },
    } = usePatientFormContext()

    return (
        <Controller
            control={control}
            name="birthDate"
            rules={{
                required: patientFormErrors.birthDate?.required,
                validate: (date) => {
                    const validations: Record<string, string | undefined> = {}

                    const isValid = dayjs(date).isValid()

                    validations.isValidDate = !isValid ? 'Le format de date saisi est invalide' : undefined

                    if (isValid) {
                        validations.isBeforeToday = !dayjs(date).isBefore(dayjs(), 'day')
                            ? "La date doit être antérieure à aujourd'hui"
                            : undefined
                        validations.isAfter1900 = !dayjs(date).isAfter(dayjs('1900-01-01'), 'year')
                            ? "La date doit être postérieure à l'année 1900"
                            : undefined
                    }

                    const errors = Object.values(validations).filter((err) => err !== undefined)

                    return errors.length > 0 ? errors.join(', ') : true
                },
            }}
            render={({ field, fieldState: { error } }) => (
                <PatientFormField
                    variant="custom"
                    label="Date de naissance"
                    name={field.name}
                    disabled={isDisabled}
                    status={{
                        error,
                        valid: Boolean(field.value),
                    }}
                    dataCy={`dataCy_PatientField-${field.name}`}
                    required
                    render={() => (
                        <LocalizationProvider
                            dateAdapter={AdapterDayjs}
                            localeText={frFR.components.MuiLocalizationProvider.defaultProps.localeText}
                        >
                            <DatePicker
                                {...field}
                                format="DD/MM/YYYY"
                                value={field.value ? dayjs.utc(field.value) : null}
                                onChange={(date) =>
                                    field.onChange(
                                        dayjs.isDayjs(date) && date.isValid()
                                            ? dayjs.utc(date.format('YYYY-MM-DD')).toISOString()
                                            : null,
                                    )
                                }
                                disabled={isDisabled}
                            />
                        </LocalizationProvider>
                    )}
                />
            )}
        />
    )
}

export default BirthDate
